<template>
  <el-table border :data="tableData">
<!--            show-overflow-tooltip-->
    <template v-for="(col, index) in columns">
      <el-table-column
        v-if="col.slot"

        :key="'column' + index"
        :prop="col.prop"
        :width="col.width"
      >
        <template slot="header" slot-scope="scope">
          <span>
            {{ col.label }}
          </span>
          <el-tooltip
            effect="light"
            content=""
            placement="top"
            v-if="col.prop === 'useFileAuditFlag'"
          >
            <div slot="content">
              开启后，如果当前审批流程中的审批人已参与了文件发起审批，则不需要再进行用印审批。
            </div>
            <i
              class="el-icon-question"
              style="font-size: 16px;margin-left: 3px;color: #a1a1a1;cursor: pointer"
            ></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <component
            @reloadList="reloadList"
            :is="col.slot"
            :data="scope.row"
          ></component>
        </template>
      </el-table-column>
      <el-table-column
        v-else
        :key="'column' + index"
        show-overflow-tooltip
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
      />
    </template>
    <no-data text="暂无数据" slot="empty" />
  </el-table>
</template>

<script>
export default {
  name: "FlowTable",
  props: {
    tableData: {
      type: Array
    },
    columns: {
      type: Array
    }
  },
  methods: {
    reloadList() {
      this.$emit("reloadList");
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-table__header {
  th {
    background-color: #f4f4f4;
    color: #000000;
  }
}
</style>



// WEBPACK FOOTER //
// components/corp-comps/FlowTable.vue